import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';

const useStyles = createUseStyles(({ spacings }: ITheme) => ({
  root: {
    pointerEvents: 'all',
    display: 'grid',
    gridAutoFlow: 'column',
    gap: spacings.s4,
    height: 40,
    borderRadius: 'var(--layout-border-radius)',
  },
  buttonGroup: {
    background: 'var(--layout-bg-color)',
    borderRadius: 'var(--layout-border-radius)',
    display: 'grid',
    gridAutoFlow: 'column',
    gap: spacings.s4,
    padding: spacings.s2,
  },
}));

export default useStyles;
